import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import Input from "./form/Input";
import CheckBox from "./form/CheckBox";

const EditUser = () => {
    const [user, setUser] = useState([]);
    let { id } = useParams();
    const { jwtToken } = useOutletContext();
    const navigate = useNavigate();

    useEffect(() => {
        if (jwtToken === "") {
            navigate("/login");
            return;
        }

        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + jwtToken);
        const requestOptions = {
            method: "GET",
            headers: headers,
        };
        fetch(
            `${process.env.REACT_APP_BACKEND}/api/users/${id}`,
            requestOptions
        )
            .then((response) => response.json())
            .then((data) => {
                setUser(data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [id, jwtToken]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + jwtToken);

        const requestOptions = {
            method: "PUT",
            headers: headers,
            body: JSON.stringify(user),
        };

        fetch(
            `${process.env.REACT_APP_BACKEND}/api/users/${id}`,
            requestOptions
        )
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                navigate(`/users/${id}`);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleChange = () => (event) => {
        let value = event.target.value;
        let name = event.target.name;
        setUser({
            ...user,
            [name]: value,
        });
    };

    return (
        <div>
            <h1>Редактирование пользователя {user && user.name}</h1>

            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <Input
                        type="text"
                        name="name"
                        title="Имя"
                        errorMessages={["Это поле обязательно для заполнения"]}
                        className="form-control"
                        id="name"
                        value={user.name}
                        onChange={handleChange("name")}
                    ></Input>
                </div>

                <div className="form-group">
                    <Input
                        type="text"
                        className="form-control"
                        id="lastName"
                        value={user.lastName}
                        title="Фамилия"
                        name="lastName"
                        onChange={handleChange("lastName")}
                    ></Input>
                </div>

                <div className="form-group">
                    <Input
                        type="email"
                        className="form-control"
                        id="email"
                        value={user.email}
                        title="Email"
                        name="email"
                        onChange={handleChange("email")}
                    ></Input>
                </div>

                <div className="form-group">
                    <Input
                        type="text"
                        className="form-control"
                        id="phone"
                        value={user.phone}
                        title="Телефон"
                        name="phone"
                        onChange={handleChange("phone")}
                    ></Input>
                </div>

                <div className="form-group">
                    <CheckBox
                        type="checkbox"
                        className="form-check-input"
                        id="active"
                        checked={user.active}
                        title="Активный"
                        name="active"
                        value={user.active}
                        onChange={handleChange("active")}
                    ></CheckBox>
                </div>

                <button type="submit" className="btn btn-primary">
                    Сохранить
                </button>
            </form>
        </div>
    );
};

export default EditUser;
